import DashboardContainer from './dashboard.container';

export default DashboardContainer;
